<mat-card class="mb-3">
    <mat-card-header>
        <!-- <div mat-card-avatar class="example-header-image">
            <img *ngIf="currentAsset.host && currentAsset.host.manufacturer && currentAsset.host.icon"
                 [matTooltip]="currentAsset.host.manufacturer"
                 class="mat-32" src="/assets/images/os/{{currentAsset.host.icon}}"
                 alt="{{currentAsset.host.host_name}}">
            <img *ngIf="currentAsset.host && !currentAsset.host.manufacturer && currentAsset.host.icon"
                 class="mat-32" src="/assets/images/os/{{currentAsset.host.icon}}"
                 alt="{{currentAsset.host.host_name}}">
        </div> -->
        <!-- <mat-card-subtitle class="mr-3 col-md-12" *ngIf="sourceColumnName && !reportBuilder">
          Total Row(s) Count : {{rowReportData && rowReportData.length > 0 ? rowReportData.length : 0}} <br/>
          Filtered Row Count : {{ filteredRowCount }} 
        </mat-card-subtitle> -->
        <ng-container>
          
        </ng-container>
    </mat-card-header>

    <mat-card-content>
        <ag-grid-angular
          #glCoutGrid
          id="glCountGrid"
          style="width: 100%; height: 250px;"
          class="ag-theme-alpine"
          [allowDragFromColumnsToolPanel]="true"
          [autoGroupColumnDef]="autoGroupColumnDef"
          [columnDefs]="columnReportData"
          [columnTypes]="columnTypes"
          [cacheQuickFilter]="true"
          [defaultColDef]="defaultColDef"
          [groupSelectsChildren]="true"
          [gridOptions]="gridOptions"
          [rowData]="rowReportData"
          
          [rowGroupPanelShow]="rowGroupPanelShow"
          [sideBar]="true"
          [suppressFieldDotNotation]="true"
          [suppressAggFuncInHeader]="true" 
          [suppressRowClickSelection]="true"
          [undoRedoCellEditing]="true"
          (filterChanged)="onFilterChanged($event)"
          (cellValueChanged)="onCellValueChanged($event)"
          (cellClicked)="onCellClicked($event)"
          (gridReady)= "onGridReady($event, 'glcount')"
          (selectionChanged)="onSelectionChanged($event);"
          (columnRowGroupChanged)="onColumnRowGroupChanged($event)"
        >
        </ag-grid-angular>
    </mat-card-content>
</mat-card>

